import { createUseStyles } from 'react-jss';
import { mobileContent } from '../../utils/mixins';
export default createUseStyles(function (theme) {
  return Object.assign({
    container: {
      display: 'flex'
    },
    innerContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: 15
    },
    row: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      flex: 1
    },
    avatar: {
      marginBottom: 5
    },
    patientSection: {
      maxWidth: 250
    },
    planSection: {
      marginTop: 15,
      display: 'flex'
    },
    scheduleId: {
      marginRight: 9,
      whiteSpace: 'nowrap'
    },
    planName: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '132px'
    },
    actions: {
      display: 'flex',
      alignSelf: 'center',
      justifyContent: 'flex-end'
    },
    grow: {
      flexGrow: 1
    },
    icon: {
      transform: 'rotate(90deg) translateY(1px)'
    },
    iconButton: {
      borderColor: theme.palette.grey[12],
      fill: theme.palette.grey[12]
    },
    button: {
      height: 35,
      marginTop: 5,
      width: '100%',
      fontSize: 12
    },
    countdown: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    badgeWrapper: {
      marginTop: 15
    }
  }, mobileContent({
    container: {
      alignItems: 'flex-start'
    },
    planSection: {
      display: 'flex',
      alignItems: 'flex-start',
      overflowX: 'hidden'
    },
    actions: {
      alignSelf: 'center'
    }
  }));
});